// Helpers for working with product size variants ({ name, sku, price_override }).
// Tolerates legacy string sizes ("S") for safety.

export function variantName(size) {
  if (size == null) return "";
  return typeof size === "string" ? size : size.name || "";
}

// Effective wholesale price for a variant: override if set, else product default.
export function variantPrice(size, product) {
  const override = typeof size === "object" && size ? size.price_override : null;
  return override != null ? Number(override) : Number(product?.wholesale_price ?? 0);
}

export function variantSku(size, product) {
  const sku = typeof size === "object" && size ? size.sku : null;
  return sku || product?.sku || "";
}

// Stock quantity for a variant (in-stock products). null = untracked/unlimited.
export function variantQty(size) {
  if (typeof size !== "object" || !size) return null;
  return size.quantity == null ? null : Number(size.quantity);
}

// Returns { min, max, hasRange } across all variant effective prices.
export function priceRange(product) {
  const base = Number(product?.wholesale_price ?? 0);
  const sizes = product?.sizes || [];
  if (!sizes.length) return { min: base, max: base, hasRange: false };
  const prices = sizes.map((s) => variantPrice(s, product));
  const min = Math.min(...prices);
  const max = Math.max(...prices);
  return { min, max, hasRange: max - min > 0.0001 };
}
